module.exports = __webpack_public_path__ + "img/background-panel-hello--dark.23d0a535.svg";